import { render } from "./companies-list-status.vue?vue&type=template&id=5d374249"
import script from "./companies-list-status.vue?vue&type=script&lang=js"
export * from "./companies-list-status.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__